import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

const Disclaimer = ({ onAgree }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  const handleAgree = () => {
    setOpen(false);
    if (onAgree) {
      onAgree();
    }
  };

  const handleClose = (event, reason) => {
    // Prevent closing by clicking outside or pressing ESC
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: '1px solid #D4A574',
        },
      }}
      disableEscapeKeyDown
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          borderBottom: '1px solid rgba(0,0,0,0.1)',
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: 600,
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.primary.main,
          }}
        >
          Disclaimer
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.05)',
            },
          }}
          disabled
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, px: 4, pb: 2 }}>
        <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            The Bar Council of India prohibits the developing of the website for the advertisement
            by an Advocate.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            By clicking &quot;I Agree&quot;, you acknowledge that this website is for{' '}
            <strong>information purposes only</strong> and not for{' '}
            <strong>advertisement, personal communication, invitation or inducement</strong> to
            solicit work.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            For more information or to get in touch with{' '}
            <strong>Advocate Priyanka Swami</strong>, you can contact at{' '}
            <strong>priyankaswami.adv@gmail.com</strong> (or other contact details as provided on
            the website).
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            Advocates are not permitted to solicit or advertise their work.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            You acknowledge that there is{' '}
            <strong>
              no any sort of advertisement, personal communication, solicitation, invitation or
              inducement
            </strong>{' '}
            from this website or its members, and they are <strong>not soliciting any work</strong>.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            Any information provided to you is upon your <strong>specific request</strong> and is
            an <strong>act of volition of the user</strong>, and does not create a{' '}
            <strong>lawyer-client relationship</strong>.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            The information is for <strong>informational purposes rigidly</strong> and should not
            be interpreted as <strong>soliciting or advertisement</strong>.
          </Typography>
          <Typography variant="body2" paragraph sx={{ color: theme.palette.text.primary }}>
            This website is{' '}
            <strong>
              neither privy nor responsible or liable for any consequence of any action taken by the
              user relying upon our material/information
            </strong>
            . Users are advised to <strong>seek independent legal advice</strong> for legal issues.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              mt: 2,
              fontStyle: 'italic',
            }}
          >
            Access will only be granted once you confirm you have read and agree to the above.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2 }}>
          <Button
            variant="contained"
            onClick={handleAgree}
            sx={{
              backgroundColor: theme.palette.secondary.main,
              color: 'white',
              px: 6,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
              },
            }}
          >
            I Agree
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Disclaimer;

